import { render } from "./LoginError.vue?vue&type=template&id=231f329a"
import script from "./LoginError.vue?vue&type=script&lang=js"
export * from "./LoginError.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mathieu/www-root/persona-tool/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__